<template>
	<div class="bind-basic">
		<el-form ref="form" :model="form" :rules="rules" label-width="120px">
			<el-form-item label="微博名称：" prop="weiboName">
				<el-input placeholder="请输入微博名称" v-model="form.weiboName" clearable>
				</el-input>
			</el-form-item>
			<el-form-item label="微博ID：" prop="weiboid">
				<el-input placeholder="请输入微博ID" v-model="form.weiboid" clearable>
				</el-input>
			</el-form-item>
		</el-form>
		<div class="footer">
			<el-button size="mini" @click="onReset">重 置</el-button>
			<el-button type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '下一步' }}
			</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		props:['show'],
		watch:{
			show:{
				handler(value){
					if(value){
						this.onReset()
					}
				},
				immediate:true
			}
		},
		data(){
			return {
				form:{
					weiboName:'',
					weiboid:''
				},
				rules:{
					weiboName:[{ required: true, message: '请输入微博名称', trigger: 'blur' }],
					weiboid:[{ required: true, message: '请输入微博ID', trigger: 'blur' }],
				},
				loading:false
			}
		},
		methods:{
			onSave(){
				this.$refs.form.validate((valid) => {
					if(valid){
						this.loading = true;
						this.$api.bindWeiboFirstForSystem(this.form).then(res => {
							this.loading = false;
							if(res.errcode != 0) return;
							this.$emit('onConfirm',this.form);
							this.$emit('getList');
						}).catch(err => {
							this.loading = false;
						})
					}
				})
			},
			onReset(){
				Object.keys(this.form).map(key => {
					this.form[key] = '';
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.bind-basic {
		.footer {
			float: right;
		}
	}
</style>
